import { defineComponent as _defineComponent } from 'vue'
import type { Locale } from '@/helpers/locale-helper';

import { computed } from 'vue';
import { editorialLocales } from '@/routing/editorial';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { buildUrlForDomain, Domain } from '@/routing/helpers/subdomain-helper';
type EditorialLocale = {
	country: string;
	webLocale: string;
	flag: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideLanding',
  setup(__props) {

const { locales, webLocale } = useLanguageStore();

const filteredLocales = computed(() =>
	locales.value.filter((locale: Locale) => editorialLocales.includes(locale.webLocale))
);

const editorialLocalesList = computed(() => {
	let localesArr: EditorialLocale[] = [];

	filteredLocales.value.map((locale: Locale) => {
		localesArr.push({
			country: locale.iso_3166_2,
			webLocale: locale.webLocale,
			flag: `${JW_CONFIG.ASSETS_URL}/flags/${locale.webLocale.toUpperCase()}.png`,
		});
	});

	return localesArr;
});

const currentLocale = computed(() => {
	return (
		editorialLocalesList.value.find(locale => locale.webLocale === webLocale.value) ??
		editorialLocalesList.value.find(locale => locale.webLocale === 'us')
	);
});

const displayedLocaleList = computed(() => {
	return editorialLocalesList.value.filter(locale => locale.webLocale !== currentLocale.value?.webLocale);
});

function getGuideHomeUrl(targetLocale: string) {
	const path = `/${targetLocale}`;
	return buildUrlForDomain(path, Domain.EDITORIAL);
}

return { __sfc: true,locales, webLocale, filteredLocales, editorialLocalesList, currentLocale, displayedLocaleList, getGuideHomeUrl, faChevronRight }
}

})